import classNames from 'classnames'
import React from 'react'

import { Link } from '@ui/components/Link'

import { TMEntityLogoFactory } from '@assets/logo/TickmillLogoIcons'

import { useLanguageMenu } from '../../menuSections/topLevelMenus/useLanguageMenu'
import { LanguagePicker } from './LanguagePicker'

import styles from './TopBar.module.scss'

export const TopBarAnon: React.FC = () => {
  const languageMenu = useLanguageMenu()

  return (
    <header className={classNames(styles.topBar, styles.topBarMinimal)}>
      <Link to='/'>
        <div className={styles.logo}>
          <TMEntityLogoFactory />
        </div>
      </Link>

      <div className={styles.spacer} />

      <div className={styles.actions}>
        <LanguagePicker languageMenu={languageMenu} />
      </div>
    </header>
  )
}
